
export const managebooking = (req)=>{
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req)
    };
    return fetch('/shared/api/nonLoginMngBooking', requestOptions).then((response) => response.json())
}
